export default {
  tabs: {
    access: 'Toegang',
    notification_preferences: 'Meldingsvoorkeuren',
  },
  sections: {
    notification_preferences: {
      title: 'Meldingsvoorkeuren',
      form: {
        has_voice_call_reminders: {
          label: 'Geautomatiseerde oproepen ontvangen over openstaande bestellingen',
        },
        voice_reminders_phone_number: {
          label: 'Telefoonnummer voor oproepen',
        },
        has_whatsapp_notifications: {
          label: 'Meldingen verzenden (bijv. bestellingen gepauzeerd) via WhatsApp',
        },
        whatsapp_phone_number: {
          label: 'WhatsApp-telefoonnummer',
        },
        has_order_email_notifications: {
          label: 'Bestelnotificaties verzenden via e-mail',
        },
        order_notifications_email: {
          label: 'E-mailadres voor bestelnotificaties',
        },
      },
    },
    voice_calls: {
      title: 'Spraakoproepen',
    },
    whats_app_notifications: {
      title: 'WhatsApp-meldingen',
    },
    order_email_notifications: {
      title: 'E-mailmeldingen voor bestellingen',
    },
    access_control: {
      title: 'Toegangscontrole',
      form: {
        company_ids: {
          label: 'Heeft toegang tot restaurants',
          tooltip: 'Geeft toegang tot de volgende restaurants (naast restaurants binnen hetzelfde merk)',
        },
      },
    },
  },
  buttons: {
    save: 'Opslaan',
  },
  toasts: {
    failed_to_save_changes: 'Opslaan van wijzigingen mislukt',
    changes_got_saved: 'Wijzigingen zijn opgeslagen',
  },
};
